import { capitalCase, sentenceCase } from 'change-case'
import { useState, useEffect, useRef, forwardRef } from 'react'
import { useSnackbar } from 'notistack';
// material
import {
  Container,
  Tab,
  Box,
  Tabs,
  Stack,
  Typography,
  MenuItem,
  TextField,
  Card,
  Grid,
  Divider,
  CircularProgress,
  AvatarGroup,
  Tooltip,
  Avatar,
  IconButton,
  Skeleton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  AppBar,
  Toolbar,
  Slide,
} from '@material-ui/core'
import { useTheme, experimentalStyled as styled } from '@material-ui/core/styles'
// components
import Posts from '../../components/projects/viewProjects/ViewTasks/Posts'
import Attachments from '../../components/projects/viewProjects/ViewTasks/Attachments'
import SubTasks from '../../components/projects/viewProjects/ViewTasks/SubTasks'
import Activities from '../../components/projects/viewProjects/ViewTasks/Activities'
import { useLocation, useNavigate, useParams } from 'react-router'
import axios from 'axios'
import { REST_API, REST_API_END_POINT } from 'src/constants/Defaultvalues'
import { UserMoreMenu } from 'src/components/_dashboard/user/list'
import AddTask from 'src/components/projects/AddTask'
import ConfirmationPopup from 'src/components/confirmationPopup';
import { PATH_DASHBOARD } from 'src/routes/paths';
import {Button} from '@material-ui/core';
import { Info, KeyboardBackspaceOutlined, Login, Logout, TryOutlined, PictureAsPdf, Close } from '@material-ui/icons';
import { Link as RouterLink } from 'react-router-dom'
import { truncate } from 'lodash';
import LoadingScreen from 'src/components/LoadingScreen';
import Label from 'src/components/Label';
import { DialogAnimate } from 'src/components/animate';
import { Icon } from '@iconify/react';
import filePdfIcon from '@iconify/icons-mdi/file-pdf';
import EstimateSubTask from 'src/components/projects/viewProjects/ViewTasks/EstimateSubTask';
import editFill from '@iconify/icons-eva/edit-fill';
import plusFill from '@iconify/icons-eva/plus-fill';
import eyeFill from '@iconify/icons-eva/eye-fill';
import EditEstimateJob from './EditEstimateJob';
import Modal from 'src/components/_dashboard/blog/ProjectModel';
import { empty } from 'src/Helpers/Common';

// ----------------------------------------------------------------------

let option = [
  { id: 1, color:'primary', value: 'New' },
  { id: 2, color:'info', value: 'In Progress' },
  { id: 3, color:'success', value: 'Completed' },
  { id: 4, color:'warning', value: 'In Testing' },
  { id: 5, color:'error', value: 'Canceled' },
  { id: 6, color:'success', value: 'Approved by Dev team' },
  { id: 7, color:'success', value: 'Approved by the client' },
  { id: 8, color:'primary', value: 'Reopen' },
]
const colors = [
  '#c9302c',
  '#5bc0de',
  '#008000',
  '#5cb85c',
  '#f0ad4e',
  '#c9302c',
  '#5cb85c',
  '#5cb85c',
  '#5bc0de',
]

const CoverImgStyle = styled('img')({
  top: 0,
  zIndex: 8,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
})

const Transition = forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);

export default function ViewEstimateTask({popupOn,postId,projectsId,taskCurrentTab,taskDetails,handleBackToAlljobs,onDataChange,requestId}) {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate()
  const { id:paramsId, projectId:paramsProjectId } = useParams();
  const id = popupOn? postId:paramsId;
  const projectId = popupOn? projectsId:paramsProjectId;

  const theme = useTheme()
  const ref = useRef(null)
  const designs =useLocation().state?.design || null
   const currentTab=popupOn ? taskCurrentTab: useLocation().state?.currentTab
   const details=popupOn ?taskDetails: useLocation().state?.details
  console.log("##############CurrentTab",useLocation());
  const logo =
    'https://t3.ftcdn.net/jpg/04/60/44/08/360_F_460440876_a8lkfz8UHz64eDPFzmSJJZ55UQBNiC0a.jpg'
  const [secTab, setSecTab] = useState('SUBTASKS')
  const [value, setValue] = useState({ id: 1, value: 'New' })
  const [data,setData] = useState(null)
  const [subTasks,setSubTasks] = useState(null)
  const [projectMembers,setProjectMembers] = useState(null)
  const [isEdit,setIsEdit] = useState(false)
  const [isDelete,setIsDelete] = useState(false)
  const [fetchData,setFetchData] = useState(false)
  const [projectPosts,setProjectPosts] = useState([])
  const [refresh,setRefresh] = useState(false)
  const [options,setOptions]= useState(option)
  const [skills,setSkills] = useState([])
  const [taskAttachments,setTaskAttachments] = useState([])
  const user = JSON.parse(window.localStorage.getItem('user'))
  const userId = user?.user_id
  const isClient = user?.isClient;
  let userType = isClient ? 3 : user.user_type
  const explodedPermissions = user?.exploded_permissions
  const canCreateEstimate = explodedPermissions?.some((permission) =>
    ['Create Estimate'].includes(permission),
  )
    ? true
    : false
  const canEditEstimate = explodedPermissions?.some((permission) =>
    ['Edit Estimate'].includes(permission),
  )
    ? true
    : false
  const canViewEstimateTaskAttachments =
    userType === 3 ||
    explodedPermissions?.some((permission) =>
      ['View Estimate Task Attachments', 'Manage Estimate Task Attachments'].includes(permission),
    )
      ? true
      : false
  const canManageEstimateTaskAttachments =
    userType !== 3 &&
    explodedPermissions?.some((permission) =>
      ['Manage Estimate Task Attachments'].includes(permission),
    )
      ? true
      : false
  const canManageEstimateTaskSubtasks =
    userType !== 3 &&
    explodedPermissions?.some((permission) =>
      ['Manage Estimate Task Subtasks'].includes(permission),
    )
      ? true
      : false
  const canUpdateEstimateSubtaskStatus =
    userType !== 3 &&
    explodedPermissions?.some((permission) =>
      ['Update Estimate Subtask Status'].includes(permission),
    )
      ? true
      : false
  // PDF modal state
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(true);
  const [useOfficeViewer, setUseOfficeViewer] = useState(true);
  const [requestDetails, setRequestDetails] = useState(null)
  const [resolvedRequestId, setResolvedRequestId] = useState(details?.request_id ?? null)
  const [projectData, setProjectData] = useState(null)
  const [loading, setLoading] = useState(false)
  const estimateRequestId = resolvedRequestId ?? details?.request_id // was: details?.request_id only (stale after design→estimate relink)
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const [openBackConfirm, setOpenBackConfirm] = useState(false)
  const editEstimateJobRef = useRef(null)
  const [isPreview, setIsPreview] = useState(false)
  const [justSubmittedEstimate, setJustSubmittedEstimate] = useState(false)
  // Helper function to check if URL is a PDF
  const isPdfUrl = (url) => {
    if (!url) return false;
    return url.toLowerCase().includes('.pdf') || url.toLowerCase().includes('application/pdf');
  }

  const handleEditClick = async () => {
    setIsOpenEdit(true)
    setIsPreview(false)
  }
  const handlePreviewClick = async () => {
    setIsOpenEdit(true)
    setIsPreview(true)
  }

  useEffect(()=>{
    if((explodedPermissions?.some(permission => ['Edit Estimate'].includes(permission))) && !justSubmittedEstimate &&
    (requestDetails && ((requestDetails?.quotation_status == 3 || requestDetails?.quotation_status == 1 || (Number(requestDetails?.is_request_estimate) === 1 && Number(requestDetails?.is_create_estimate) === 1)) && (requestDetails?.estimate_job_status == 2 || projectData?.status == 2)) && requestDetails?.quotation !== 0)){ // was: ((requestDetails?.quotation_status == 3 || requestDetails?.quotation_status == 1) && (requestDetails?.estimate_job_status == 2))
      handleEditClick()
    }
    // else{ 
    //   (enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' }))
    // }
  },[requestDetails])
  console.log("##############requestDetails",requestDetails);
  console.log("##############details",details);

  const TABS = [
    {
      value: 'SUBTASKS',
      component: <EstimateSubTask requestDetails={requestDetails} details={details} taskData={data} data={subTasks} setFetchData={setFetchData} projectMembers={projectMembers} taskId={id} projectId={projectId} setRefresh={setRefresh} refresh={refresh} currentTab={currentTab} onDataChange={onDataChange} canManage={canManageEstimateTaskSubtasks} canUpdateStatus={canUpdateEstimateSubtaskStatus} />,
    },
    {
      value: 'POSTS',
      component: <Posts projectPosts={projectPosts} taskId={Number(id)} projectId={projectId}
        refresh={refresh} setRefresh={setRefresh} currentTab={currentTab}/>,
    },
    ...(canViewEstimateTaskAttachments
      ? [
          {
            value: 'ATTACHMENTS',
            component: (
              <Attachments
                taskId={Number(id)}
                projectId={projectId}
                details={details}
                refresh={refresh}
                setRefresh={setRefresh}
                currentTab={currentTab}
                taskData={data}
                taskAttachments={taskAttachments}
                canManage={canManageEstimateTaskAttachments}
              />
            ),
          },
        ]
      : []),
    {
      value: 'SKILLS',
      component: <Activities skills={skills}/>,
    },
  ]

  useEffect(() => {
    try {
      axios.post(`${REST_API_END_POINT}project/fetch-all-project-sub-task`,{
        taskId: Number(id),userType: user.user_type, userId: user.user_id,requestId:estimateRequestId // was: details?.request_id
      },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){
          setSubTasks(response.data.result)
          setSkills(response.data.skills)
        }
      }).catch((error) => {
        console.error(error);
      })
      setFetchData(false)
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }, [fetchData, estimateRequestId])

  useEffect(() => {
    try {
      axios.post(`${REST_API_END_POINT}project/view-project-task`,{ taskId: id, projectId,userId: user.user_id},{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){
          setProjectPosts(response.data.projectPost)
          setData(response.data.result[0])
          setProjectMembers(response.data.projectMembers)
         
          // Assume 'statusValue' is the value you want to filter by

       option = option.filter(opt => opt.id=== response.data.result[0].status);
       setOptions(option)
         
        }
      
      }).catch((error) => {
        console.error(error);
      })
      // handleFetchEditData(id)
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }, [isEdit,refresh])

  useEffect(() => {
    if(data?.status){
      setValue(option.find(opt=>opt.id === data.status))
    }
  }, [data])

  const handleDeleteTask = ()=>{
    try {
      // const  user  = JSON.parse(window.localStorage.getItem('user'))
      axios.post(`${REST_API_END_POINT}project/delete-project-task`,{ id: Number(id),projectId, status: 0 },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 4){
          enqueueSnackbar(response.data.message, { variant: 'success' });
         if(popupOn){
          // onDataChange()
          handleBackToAlljobs()
         }
          else{ navigate(PATH_DASHBOARD.quotation.viewEstimateProject+projectId)}
        }else if(response.data.status === 5){
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
        setIsDelete(false)
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }

  const handleTab = (event, newValue) => {
    setSecTab(newValue)
  }


  useEffect(()=>{
    fetchAttachmentsFromTask()
  },[id])

  useEffect(() => {
    if (!projectId) return
    const fetchProjectRequestId = async () => {
      try {
        const response = await axios.post(`${REST_API_END_POINT}project/get-project-by-id`, {
          id: { value: projectId },
          userId: user.user_id,
          userType: user.user_type,
          hasPermission: true,
        })
        const result = response.data?.result
        if (result?.request_id) setResolvedRequestId(result.request_id)
        setProjectData(result)
      } catch (error) {
        console.error('Error fetching project request id:', error)
      }
    }
    fetchProjectRequestId()
  }, [projectId, refresh])

  const fetchRequestDetails = async () => {
    if (!estimateRequestId) return
    try {
      setLoading(true)
      const res = await axios.post(`${REST_API}webservice/request/view-estimate-job`, { request_id: estimateRequestId,userId, userType }); // was: details?.request_id
      setRequestDetails(res.data?.data[0])
    } catch (error) {
      console.error('Error fetching request details:', error);
      setRequestDetails(null)
    }finally{
      setLoading(false)
    }
  };

  useEffect(()=>{
    fetchRequestDetails()
  },[estimateRequestId, refresh])

  const fetchAttachmentsFromTask =async()=>{
    const response = await axios.post(`${REST_API_END_POINT}project-task/fetch-all-designs-from-task`,{id,requestId: estimateRequestId ?? requestId,projectId}) // was: requestId
    if(response.data.status==1){
      setTaskAttachments(response?.data?.attachments)
    }else{
      setTaskAttachments([])
    }
  }

  return (
    <Container sx={{mt:2}}>
      {/* {loading ? 
        <LoadingScreen sx={{ top: 0, left: 0, width: 1, zIndex: 9999, position: 'fixed' }} />
      :
        <> */}
          <Stack justifyContent='space-between' flexDirection='row'>
            {popupOn?<Button
              variant="outlined"
              type="submit"
              onClick={handleBackToAlljobs}
              state={{currentTab:currentTab}}
              sx={{ alignItems: 'flex-end', mb: 3.5 }}
              startIcon={ // Use the startIcon prop to add an icon to the left
                <Stack>
                  <KeyboardBackspaceOutlined/>
                </Stack>

              }
            >
              Back to Job Details
            </Button>:
            <Button
            variant="outlined"
            type="submit"
            component={RouterLink}
            to={PATH_DASHBOARD.quotation.viewEstimateProject+projectId}
            state={{currentTab:currentTab}}
            sx={{ alignItems: 'flex-end', mb: 3.5 }}
            startIcon={ // Use the startIcon prop to add an icon to the left
              <Stack>
                <KeyboardBackspaceOutlined/>
              </Stack>

            }
          >
            Back to Job Details
          </Button>}
          </Stack>
          <Stack spacing={5}>
            <Stack
              // direction="row"
              alignItems="center"
              justifyContent="center"
              sx={{
                background:
                  theme.palette.mode === 'light' ? theme.palette.background.paper : theme.palette.grey[800],
                borderRadius: 2,
                boxShadow: theme.palette.mode === 'light' ? `0 0 20px ${theme.palette.grey[300]}` : 'none',
              }}
            >
              <Grid container justifyContent={'center'}>
                <Grid item xs={8} pt={4}>
                  <Stack spacing={3}>
                    <Card
                      style={{
                        border: theme.palette.mode === 'light' ? `2px solid ${theme.palette.grey[300]}` : 'none',
                        boxShadow: theme.palette.mode === 'light' ? `0 0 20px ${theme.palette.grey[500]}` : 'none',
                        height: 300,
                        width: '100%',
                        position: 'relative',
                        // backgroundImage:
                        //   `url(${data?.cover_image})`,
                      }}
                    >
                      {(() => {
                        const imageUrl = (data?.product_design && data?.approved==1) 
                          ? data?.product_design 
                          : data?.avatarUrl 
                          ? data?.avatarUrl
                          : logo;
                        const isPdf = isPdfUrl(imageUrl);
                        
                        if (isPdf) {
                          return (
                            <Box
                              sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'rgba(0, 0, 0, 0.05)',
                              }}
                            >
                              <Tooltip title="View PDF">
                                <IconButton
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setPdfLoading(true);
                                    setSelectedPDF(imageUrl);
                                    setOpenPDFModal(true);
                                    setUseOfficeViewer(true);
                                  }}
                                  aria-label="open pdf"
                                  sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: 200,
                                    color: theme.palette.error.main,
                                    backgroundColor: theme.palette.text.primary,
                                  }}
                                >
                                  <PictureAsPdf style={{ fontSize: 50 }} />
                                </IconButton>
                              </Tooltip>
                              <iframe
                                src={imageUrl}
                                title={imageUrl}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                }}
                                frameBorder="0"
                              />
                            </Box>
                          );
                        }
                        return (
                          <CoverImgStyle src={imageUrl} />
                        );
                      })()}
                    </Card>
                    <Stack
                      direction={{ xs: 'column', sm: 'row' }}
                      sx={{
                        '& .MuiTypography-root': {
                          color: theme.palette.mode === 'light' ? theme.palette.text.primary : 'inherit',
                        },
                      }}
                      spacing={3}
                      justifyContent={'flex-start'}
                      alignItems={'center'}
                    >
                      <Typography variant="h4" >{data?.name}</Typography>
                      {(data?.service_id && !data?.service_workflow) ? (
                        <Stack
                          direction={{ xs: 'column', sm: 'row' }}
                          spacing={1}
                          justifyContent={'flex-start'}
                          alignItems={'center'}
                        >
                          <Info sx={{ color: theme.palette.error.main  }} />
                          <Typography sx={{ color: theme.palette.error.main }}>
                            No service workflow has been chosen.
                          </Typography>
                        </Stack>
                      ) : ''}
                    </Stack>
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                      <Stack direction={'row'} spacing={1}>
                        {/* <Typography variant="subtitle2">{data?.member_count} Members</Typography> */}
                        <Typography variant="subtitle2">{(data?.file_count +taskAttachments.length)} Attachments</Typography>
                      </Stack>
                      {(userType!=3) ? 
                      <Stack>
                        <Stack flexDirection={'row'} gap={2}>
                          {loading ? (
                              <Stack flexDirection={'row'} alignItems='center' justifyContent='center'>
                                <CircularProgress color="primary" variant="indeterminate" />
                                {/* <Typography variant='body2'>Loading data...</Typography> */}
                              </Stack>
                            ) : (
                              // <Tooltip title="Edit Estimate">
                              //   <IconButton sx={{backgroundColor:theme.palette.divider}} onClick={()=>{(explodedPermissions?.some(permission => ['Edit Estimate'].includes(permission))) ? handleEditClick() : (enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' }))}}>
                              //       <Icon icon={editFill} width={24} height={24} color="#ffffff"/>
                              //   </IconButton>
                              // </Tooltip>
                              <>
                                {(requestDetails && ((requestDetails?.quotation_status == 3 || requestDetails?.quotation_status == 1 || (Number(requestDetails?.is_request_estimate) === 1 && Number(requestDetails?.is_create_estimate) === 1)) && (requestDetails?.estimate_job_status == 2 || projectData?.status == 2)) // was: ((requestDetails?.quotation_status == 3 || requestDetails?.quotation_status == 1) && (requestDetails?.estimate_job_status == 2))
                                && requestDetails?.quotation !== 0) ?
                                  (requestDetails?.is_create_estimate == 1 ? canEditEstimate : canCreateEstimate) ? (
                                    <Button
                                      variant='contained'
                                      onClick={() => {
                                        const allowed = requestDetails?.is_create_estimate == 1 ? canEditEstimate : canCreateEstimate
                                        if (!allowed) {
                                          enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
                                          return
                                        }
                                        handleEditClick()
                                      }}
                                      startIcon={<Icon icon={ requestDetails?.is_create_estimate == 1 ? editFill : plusFill} width={20} height={20} />}
                                    >
                                      {requestDetails?.is_create_estimate == 1 ? 'Edit Estimate' : 'Create Estimate'}
                                    </Button>
                                  ) : null
                                : (requestDetails && ((requestDetails?.quotation_status == 3 || requestDetails?.quotation_status == 1 || (Number(requestDetails?.is_request_estimate) === 1 && Number(requestDetails?.is_create_estimate) === 1)) && ((requestDetails?.estimate_job_status == 3 && requestDetails?.is_create_estimate == 1) || projectData?.status == 3)) // was: ((requestDetails?.quotation_status == 3 || requestDetails?.quotation_status == 1) && (requestDetails?.estimate_job_status == 3 && requestDetails?.is_create_estimate == 1))
                                && requestDetails?.quotation !== 0) ?
                                  (canEditEstimate ? (
                                    <Button
                                      variant='contained'
                                      onClick={() => {
                                        if (!canEditEstimate) {
                                          enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
                                          return
                                        }
                                        handlePreviewClick()
                                      }}
                                      startIcon={<Icon icon={eyeFill} width={20} height={20} />}
                                    >
                                      Preview Estimate
                                    </Button>
                                  ) : null)
                                : ''}
                              </>
                            )
                          }
                        </Stack>
                      </Stack>:""}
                    </Stack>
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                      <Box sx={{ display: 'flex',justifyContent:'flex-start', alignItems: 'center',}}>
                        <Stack>    
                          <Typography variant="subtitle2">
                              Job Members
                          </Typography>             
                          <AvatarGroup max={4}>
                            {projectMembers?.map((row)=>( 
                                <Tooltip key={row.id} title={row.name}>             
                              <Avatar src={row.profile_pic} alt={row.name} />
                              </Tooltip>                   
                            ))}
                          </AvatarGroup>
                        </Stack>
                      </Box>
                    </Stack>
                    <Divider />
                    <Tabs
                      value={secTab}
                      scrollButtons="auto"
                      variant="scrollable"
                      allowScrollButtonsMobile
                      onChange={handleTab}
                    >
                      {TABS.map((tab) => (
                        <Tab
                          disableRipple
                          key={tab.value}
                          label={
                            <Typography variant="overline">
                              {capitalCase(tab.value)}
                            </Typography>
                          }
                          icon={tab.icon}
                          value={tab.value}
                        />
                      ))}
                    </Tabs>
                  </Stack>
                </Grid>
              </Grid>
            </Stack>
            <Stack sx={{ alignItems: 'center', mb: 2 }} spacing={2}>
              {TABS.map((tab) => {
                const isMatched = tab.value === secTab
                return (
                  isMatched && (
                    <Box sx={{ width: '75%' }} key={tab.value}>
                      {tab.component}
                    </Box>
                  )
                )
              })}
            </Stack>
          </Stack>
          <AddTask data={data} setData={setData} projectMembers={projectMembers} projectId={Number(data?.project_id)} add={isEdit} setAdd={setIsEdit} refresh={refresh} setRefresh={setRefresh} />
          <ConfirmationPopup open={isDelete} handleClick={handleDeleteTask} message={'Want to Delete This Task'} handleClose={()=>setIsDelete(false)}/>
          
          {/* PDF Modal Dialog */}
          <DialogAnimate open={openPDFModal} onClose={() => setOpenPDFModal(false)}>
            <Card sx={{ padding: 3, maxWidth: 768, margin: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{width:'90%', display:'flex',justifyContent:'flex-end', marginBottom: '15px',marginLeft:'25px' }}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    if (isClient || userType === 3) {
                      // For clients/userType 3: Open PDF in new window without toolbar
                      const newWindow = window.open('', '_blank');
                      newWindow.document.write(`
                        <html>
                          <head>
                            <title>PDF Viewer</title>
                            <style>
                              body { margin: 0; padding: 0; overflow: hidden; }
                              iframe { width: 100vw; height: 100vh; border: none; }
                            </style>
                          </head>
                          <body>
                            <iframe src="${selectedPDF}#toolbar=0&navpanes=0&scrollbar=0" title="PDF Viewer"></iframe>
                          </body>
                        </html>
                      `);
                      newWindow.document.close();
                    } else {
                      // For other users: Open PDF normally
                      window.open(selectedPDF, '_blank');
                    }
                  }}
                  disabled={!selectedPDF}
                  startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                  sx={{
                    fontSize:'14px'
                  }}
                >
                  View PDF
                </Button>
              </div>
              {pdfLoading && (
                <Skeleton variant="rectangular" width="100%" height={500} />
              )}

              {(isClient || userType === 3) && useOfficeViewer ? (
                <iframe
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true&toolbar=0&navpanes=0&scrollbar=0`}
                  title="Selected PDF"
                  width="100%"
                  height="500px"
                  frameBorder="0"
                    sandbox="allow-scripts allow-same-origin"
                  style={{ display: pdfLoading ? 'none' : 'block' }}
                  onLoad={() => setPdfLoading(false)}
                  onError={() => {
                    // If Google Docs viewer fails, fallback to direct iframe
                    setUseOfficeViewer(false);
                    setPdfLoading(false);
                  }}
                />
              ) : (
                <iframe
                  src={selectedPDF}
                  title="Selected PDF"
                  width="100%"
                  height="500px"
                  frameBorder="0"
                  style={{ display: pdfLoading ? 'none' : 'block' }}
                  onLoad={() => setPdfLoading(false)}
                />
              )}
            </Card>
          </DialogAnimate>
        {/* </>
      } */}
      <Dialog fullScreen open={isOpenEdit}  TransitionComponent={Transition}>
        <AppBar position="relative" mb={1}>
          <Toolbar sx={{ minHeight: '48px !important', py: 0.5 }}>
            <Typography variant="subtitle1" sx={{ flex: 1, ml: 1, fontSize: '1rem' }}>
              {requestDetails?.estimate_job_status == 3 ? 'Preview Estimate' : requestDetails?.is_create_estimate == 1 ? 'Edit Estimate' : 'Create Estimate'}
            </Typography>
              <Close
                onClick={() => {
                  if (isPreview) {
                    setIsOpenEdit(false)
                    setIsPreview(false)
                  } else {
                    setOpenBackConfirm(true)
                  }
                }}
                sx={{ fontSize: '1.8rem', cursor: 'pointer' }}
              />
          </Toolbar>
        </AppBar>
        <EditEstimateJob ref={editEstimateJobRef} isPreview={isPreview} setIsPreview={setIsPreview} setJustSubmittedEstimate={setJustSubmittedEstimate} setIsOpenEdit={setIsOpenEdit} estimateId={estimateRequestId} isEditEstimateJob={true} setRefreshRFQData={setRefresh} refreshRFQData={refresh} /> {/* was: estimateId={details?.request_id} */}
      </Dialog>
      <Dialog open={openBackConfirm} onClose={() => setOpenBackConfirm(false)}>
        <DialogTitle>Auto Save</DialogTitle>
        <DialogContent>
          <DialogContentText>Do you want to auto save before closing?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenBackConfirm(false); editEstimateJobRef.current?.submitForm?.(); }} color="primary" variant="contained">
            Yes, Auto Save
          </Button>
          <Button
            onClick={async () => {
              setOpenBackConfirm(false)
              // Same discard path as EditEstimateJob Cancel button
              if (estimateRequestId) {
                try {
                  await axios.post(`${REST_API}webservice/request/discard-pending-estimate-catalogs`, {
                    requestId: estimateRequestId,
                    userId,
                    estimateName: requestDetails?.name || details?.name || null,
                  })
                } catch (error) {
                  console.error('Failed to discard pending estimate catalogs:', error)
                }
              }
              setIsOpenEdit(false)
              setIsPreview(false)
            }}
            color="inherit"
          >
            No, Go Back
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  )
}
